<template>
  <a-modal
    :title="title"
    :visible="open"
    :maskClosable="false"
    :keyboard="false"
    @cancel="importExcelHandleCancel"
    @ok="importExcelHandleChange"
  >
    <a-spin tip="上传中..." :spinning="uploading">
      <a-card title="剧集导入" style="width: 100%">
        <a-upload-dragger
          name="file"
          accept=".mp4"
          :multiple="true"
          :show-upload-list="false"
          list-type="picture"
          :customRequest="handleChange"
          @change="changeFile"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（导入的文件名请以视频集数命名。比如第一集视频名称为：1.MP4）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadVideoing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" />
              <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />
              {{ item.name }}
              <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" ></a-progress>

            </div>
            <a-icon type="delete" @click.stop="clickDelete(index,1)" />
            <!--            <a-icon type="delete" @click.stop="clickDelete(index,1)" v-if="item.percent == 100" />-->
          </div>
          <!--          <div style="width: 100%;display: flex;justify-content: space-between">-->
          <!--            <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" ></a-progress>-->
          <!--            <a-icon type="delete" @click.stop="clickDelete(index,1)" /></div>-->
        </div>
      </a-card>

      <a-card title="字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeIn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileInList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadIning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileInList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,6)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>


      <a-card title="英文字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeEn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileEnList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadEning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileEnList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,3)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>

      <a-card title="法语字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt,.mov"
          :multiple="true"
          :show-upload-list="false"
          :customRequest="handleChangeCn"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileCnList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadCning"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileCnList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,4)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />

        </div>
      </a-card>
      <a-card title="阿拉伯字幕" style="width: 100%;margin-top: 10px">
        <a-upload-dragger
          name="file"
          accept=".srt,.vtt"
          :multiple="true"
          :show-upload-list="false"
          list-type="picture"
          :customRequest="handleChangeZh"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>
        </a-upload-dragger>
        <div style="margin-top: 10px;margin-bottom: 10px">
          <a-card>
            <a-row type="flex">
              <a-statistic title="总计" :value="fileZhList.length" />
              <a-statistic
                title="正在上传"
                :value="computedUploadZhing"
                :style="{
                  margin: '0 32px',
                }"
                :value-style="{ color: '#cf1322' }"
              />
            </a-row>
          </a-card>

        </div>
        <div style="margin-bottom: 5px" v-for="(item,index) in fileZhList" :key="index" >
          <div style="width: 100%;display: flex;justify-content: space-between">
            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>
            <a-icon type="delete" @click.stop="clickDelete(index,2)" v-if="item.percent == 100" />

          </div>
          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />
        </div>
      </a-card>



<!--      <a-card title="西班牙语字幕" style="width: 100%;margin-top: 10px">-->
<!--        <a-upload-dragger-->
<!--          name="file"-->
<!--          accept=".srt,.vtt,.mov"-->
<!--          :multiple="true"-->
<!--          :show-upload-list="false"-->
<!--          :customRequest="handleChangeBm"-->
<!--        >-->
<!--          <p class="ant-upload-drag-icon">-->
<!--            <a-icon type="inbox" />-->
<!--          </p><div><font style="color: red">（请上传.srt,.vtt文件）</font></div>-->
<!--        </a-upload-dragger>-->
<!--        <div style="margin-top: 10px;margin-bottom: 10px">-->
<!--          <a-card>-->
<!--            <a-row type="flex">-->
<!--              <a-statistic title="总计" :value="fileBmList.length" />-->
<!--              <a-statistic-->
<!--                title="正在上传"-->
<!--                :value="computedUploadBming"-->
<!--                :style="{-->
<!--                  margin: '0 32px',-->
<!--                }"-->
<!--                :value-style="{ color: '#cf1322' }"-->
<!--              />-->
<!--            </a-row>-->
<!--          </a-card>-->

<!--        </div>-->
<!--        <div style="margin-bottom: 5px" v-for="(item,index) in fileBmList" :key="index" >-->
<!--          <div style="width: 100%;display: flex;justify-content: space-between">-->
<!--            <div><a-icon type="loading" v-if="item.percent != 100" style="margin-right: 10px" /> <a-icon type="link" v-if="item.percent == 100" style="margin-right: 10px" />{{ item.name }}</div>-->
<!--            <a-icon type="delete" @click.stop="clickDelete(index,5)" v-if="item.percent == 100" />-->

<!--          </div>-->
<!--          <a-progress style="height: 2px" v-if="item.percent != 100" :percent="item.percent" :show-info="false" />-->

<!--        </div>-->
<!--      </a-card>-->



      <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
        <img alt="example" style="width: 100%" :src="previewImage" />
      </a-modal>
    </a-spin>
  </a-modal>
</template>

<script>

import { importData } from '@/api/video/gather'
import UploadFileToVOD from '@/api/vod'

import UploadFileToVODFile from '@/api/UploadFileToVOD'
import axios from 'axios'
import UploadFileToOSS from '@/utils/upload-file-to-oss'
import { uploadObject, uploadOss, ensureHttpsUrl } from '@/api/tool/oss'
import { getSTSToken } from '@/api/tool/common'
import COS from 'cos-js-sdk-v5'
export default {
  name: 'ImportExcel',
  props: {
  },
  components: {
  },
  data () {
    return {
      title: '导入',
      open: false,
      uploadStatus: '',
      previewImage: '',
      fileList: [],
      fileZhList: [],
      fileEnList: [],
      fileCnList: [],
      fileBmList: [],
      fileInList: [],
      // 是否禁用上传
      uploading: false,
      previewVisible: false,
      updateSupport: 0,
      id: ''
    }
  },

  filters: {
  },
  created () {
  },
  computed: {
    computedUploadVideoing() {
      if (this.fileList.length > 0) {
        return this.fileList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadZhing() {
      if (this.fileZhList.length > 0) {
        return this.fileZhList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadEning() {
      if (this.fileEnList.length > 0) {
        return this.fileEnList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadCning() {
      if (this.fileCnList.length > 0) {
        return this.fileCnList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadBming() {
      if (this.fileBmList.length > 0) {
        return this.fileBmList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    },
    computedUploadIning() {
      if (this.fileInList.length > 0) {
        return this.fileInList.filter(i => {
          return i.percent != 100 || i.url === ''
        }).length
      } else {
        return 0
      }
    }
  },
  watch: {
  },
  methods: {
    clickDelete(index, num) {
      const that = this
      this.$confirm({
        content: '是否确认删除呢?',
        centered: true,
        onOk() {
          if (num == 1) {
            that.fileList.splice(index, 1)
          }
          if (num == 2) {
            that.fileZhList.splice(index, 1)
          }
          if (num == 3) {
            that.fileEnList.splice(index, 1)
          }
          if (num == 4) {
            that.fileCnList.splice(index, 1)
          }
          if (num == 5) {
            that.fileBmList.splice(index, 1)
          }
          if (num == 6) {
            that.fileInList.splice(index, 1)
          }
        },
        onCancel() {
          // that.open = false
          // that.fileList = [];
          // that.fileEnList = [];
          // that.fileZhList = [];
        }
      })
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleCancel() {
      this.previewVisible = false
    },

    changeFile(info) {
      // console.log('11111111111111111111111')
      // console.log(info)
      // this.fileList.push({
      //   uid:info.file.uid,
      //   name:info.file.name,
      //   status: 'done',
      //   url:'',
      //   percent:0
      // })
    },
    handleChange(info) {
      this.fileList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'done',
        url: '',
        percent: 0
      })
      const that = this
      // that.form.videoUrl = ""
      const findIndex = that.fileList.findIndex(i => i.uid == info.file.uid)
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          if (findIndex != -1) {
            that.$set(that.fileList[findIndex], 'percent', 100)
            that.fileList[findIndex].url = fileName[0]
            that.$set(that.fileList[findIndex], 'url', fileName[0])
          }
        },
        vProgress: function (val) {
          if (findIndex != -1) {
            that.fileList[findIndex].percent = val * 100
            that.$set(that.fileList[findIndex], 'percent', val * 100)
          }
        },
        // fileId: function (val) {
        //   if (findIndex != -1) {
        //     that.fileList[findIndex].fileId = val
        //     that.$set(that.fileList[findIndex], 'fileId', val)
        //   }
        // }
      })
    },

    async handleChangeZh(info) {
      this.fileZhList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })
      const that = this
      const findIndex = that.fileZhList.findIndex(i => i.uid == info.file.uid)

      try {
        // 1. 生成文件路径
        const filePath = uploadOss(info.file.name, 'subtitle/zh')
        console.log('========== 开始上传流程 ==========')
        console.log('文件路径:', filePath)
        console.log('文件信息:', {
          name: info.file.name,
          size: info.file.size,
          type: info.file.type
        })

        // 重要提示：如果遇到 CORS 错误，请检查以下内容
        console.log('⚠️ CORS 排查提示：')
        console.log('1. 打开浏览器 Network 面板（F12）')
        console.log('2. 勾选 "Disable cache"')
        console.log('3. 查找 OPTIONS 请求，检查状态码（必须是 200）')
        console.log('4. 检查 OPTIONS 的 Response Headers 是否包含 CORS 相关头')
        console.log('5. 如果 OPTIONS 返回 403/405，说明腾讯云 COS CORS 配置不正确')
        console.log('6. 确保腾讯云控制台 CORS 配置中 Allow-Headers 设置为 *（星号）')

        // 2. 使用 getAuthorization 回调方式，动态获取临时凭证
        // 这种方式可以避免在初始化时就传入密钥，可能有助于解决 CORS 问题
        const cos = new COS({
          // 使用 getAuthorization 回调动态获取签名
          getAuthorization: async function(options, callback) {
            try {
              console.log('========== 开始获取上传凭证 ==========')
              console.log('请求选项:', options)
              const stsToken = await getSTSToken()
              console.log('获取到的凭证:', stsToken)

              if (!stsToken || !stsToken.data) {
                console.error('凭证数据为空')
                callback('获取COS凭证失败')
                return
              }

              // 计算过期时间（10位时间戳，秒）
              const startTime = Math.floor(Date.now() / 1000)
              const expiredTime = startTime + 1800 // 30分钟

              console.log('签名时间范围:', startTime, '到', expiredTime)

              // 返回签名信息
              callback({
                TmpSecretId: stsToken.data.accessKeyId,
                TmpSecretKey: stsToken.data.accessKeySecret,
                XCosSecurityToken: stsToken.data.securityToken,
                ExpiredTime: expiredTime,
                StartTime: startTime
              })
              console.log('========== 凭证获取完成 ==========')
            } catch (error) {
              console.error('========== 获取凭证失败 ==========')
              console.error('错误详情:', error)
              callback(error.message || '获取COS凭证失败')
            }
          },
          Protocol: 'https:',
          Timeout: 60000,
          UseAccelerate: false,
          CorrectClockSkew: true // 修正时钟偏移
        })

        // 添加请求拦截，记录所有网络请求
        console.log('========== COS 客户端初始化完成 ==========')
        console.log('COS 配置:', {
          Protocol: 'https:',
          Timeout: 60000,
          UseAccelerate: false,
          CorrectClockSkew: true
        })

        // 3. 先获取一次凭证以获取 bucket 和 region 信息
        console.log('获取存储桶和地域信息...')
        const stsToken = await getSTSToken()
        if (!stsToken || !stsToken.data) {
          throw new Error('获取COS凭证失败')
        }

        const bucket = stsToken.data.bucket
        const region = stsToken.data.region
        console.log('存储桶:', bucket)
        console.log('地域:', region)

        // 4. 对于小文件，使用 putObject（简单上传，CORS更友好）
        // 对于大文件，使用 uploadFile（分片上传）
        const fileSize = info.file.size
        const isLargeFile = fileSize > 5 * 1024 * 1024 // 5MB

        console.log('文件大小:', fileSize, '字节，是否大文件:', isLargeFile)

        // 构建上传 URL 用于调试
        const uploadUrl = `https://${bucket}.cos.${region}.myqcloud.com/${filePath}`
        console.log('========== 准备上传文件 ==========')
        console.log('上传 URL:', uploadUrl)
        console.log('文件信息:', {
          name: info.file.name,
          size: fileSize,
          type: info.file.type
        })

        let uploadResult
        if (isLargeFile) {
          console.log('使用分片上传...')
          // 大文件使用分片上传
          uploadResult = await cos.uploadFile({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            SliceSize: 1024 * 1024 * 5, // 5MB分块
            ContentType: info.file.type || 'application/octet-stream',
            Headers: {}, // 明确设置空头，避免 SDK 添加可能导致 CORS 问题的头
            onProgress: function(progressData) {
              if (findIndex != -1) {
                const percent = Math.round(progressData.percent * 100)
                that.$set(that.fileZhList[findIndex], 'percent', percent)
              }
            }
          })
        } else {
          console.log('使用简单上传 putObject...')
          // 小文件使用 putObject（简单上传，避免复杂的预检请求）
          uploadResult = await cos.putObject({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            ContentType: info.file.type || 'application/octet-stream',
            Headers: {}, // 明确设置空头，避免 SDK 添加可能导致 CORS 问题的头
            onProgress: function(progressData) {
              if (findIndex != -1) {
                // putObject 的进度格式可能不同
                let percent = 0
                if (progressData.percent !== undefined) {
                  percent = Math.round(progressData.percent * 100)
                } else if (progressData.loaded && progressData.total) {
                  percent = Math.round((progressData.loaded / progressData.total) * 100)
                }
                that.$set(that.fileZhList[findIndex], 'percent', percent)
              }
            }
          })
        }

        console.log('========== 上传完成 ==========')
        console.log('上传结果:', uploadResult)

        // 检查上传结果
        if (uploadResult && (uploadResult.statusCode === 200 || uploadResult.ETag || uploadResult.Location)) {
          // 上传成功，构建文件URL
          let url = ''
          if (stsToken.data.staticUrl) {
            url = stsToken.data.staticUrl + (stsToken.data.staticUrl.endsWith('/') ? '' : '/') + filePath
          } else if (uploadResult.Location) {
            url = uploadResult.Location
          } else {
            // 构建COS文件的访问URL（使用之前获取的 bucket 和 region）
            url = `https://${bucket}.cos.${region}.myqcloud.com/${filePath}`
          }
          // 确保 URL 包含 https:// 前缀
          url = ensureHttpsUrl(url)

          if (findIndex != -1) {
            that.$set(that.fileZhList[findIndex], 'percent', 100)
            that.$set(that.fileZhList[findIndex], 'status', 'done')
            that.fileZhList[findIndex].url = url
            that.$set(that.fileZhList[findIndex], 'url', url)
          }
        } else {
          throw new Error('上传失败，返回结果异常')
        }
      } catch (error) {
        console.error('========== 上传失败详情 ==========')
        console.error('错误对象:', error)
        console.error('错误消息:', error.message)
        console.error('错误代码:', error.code)
        console.error('状态码:', error.statusCode)
        console.error('错误堆栈:', error.stack)

        // 尝试解析更多错误信息
        if (error.error) {
          console.error('错误详情:', error.error)
        }
        if (error.request) {
          console.error('请求对象:', error.request)
        }
        if (error.response) {
          console.error('响应对象:', error.response)
          console.error('响应状态:', error.response.status)
          console.error('响应头:', error.response.headers)
        }

        let errorMessage = '上传失败：'
        let isCorsError = false

        // 检查是否是网络错误或 CORS 错误
        if (error.message) {
          const msg = error.message.toLowerCase()
          isCorsError = msg.includes('cors') ||
            msg.includes('cross-origin') ||
            msg.includes('access-control') ||
            msg.includes('blocked') ||
            msg.includes('network error') ||
            msg.includes('failed to fetch') ||
            msg.includes('networkerror')

          errorMessage += error.message
        } else if (error.statusCode) {
          errorMessage += `HTTP 状态码：${error.statusCode}`
          if (error.statusCode === 0 || error.statusCode === '0') {
            isCorsError = true
            errorMessage += '（可能是跨域或网络错误）'
          }
        } else if (error.code) {
          errorMessage += `错误代码：${error.code}`
          if (error.code === 'NetworkError' || error.code === 'CORS_ERROR') {
            isCorsError = true
          }
        } else {
          errorMessage += '未知错误'
        }

        // 如果是跨域错误，给出详细提示
        if (isCorsError) {
          console.error('========== 检测到跨域错误 ==========')
          console.error('错误详情:', {
            message: error.message,
            code: error.code,
            statusCode: error.statusCode,
            stack: error.stack
          })


        }

        console.error('========== 错误信息结束 ==========')

        if (findIndex != -1) {
          that.$set(that.fileZhList[findIndex], 'status', 'error')
          that.$set(that.fileZhList[findIndex], 'percent', 0)
          that.$message.error(errorMessage)
        }
      }
    },

    // 通用的 COS 直传方法
    async uploadToCos(info, fileList, prefix, listName) {
      fileList.push({
        uid: info.file.uid,
        name: info.file.name,
        status: 'uploading',
        url: '',
        percent: 0
      })
      const that = this
      const findIndex = fileList.findIndex(i => i.uid == info.file.uid)

      try {
        // 1. 生成文件路径
        const filePath = uploadOss(info.file.name, prefix)
        console.log(`========== 开始上传流程 (${prefix}) ==========`)
        console.log('文件路径:', filePath)

        // 2. 使用 getAuthorization 回调方式，动态获取临时凭证
        const cos = new COS({
          getAuthorization: async function(options, callback) {
            try {
              const stsToken = await getSTSToken()
              if (!stsToken || !stsToken.data) {
                callback('获取COS凭证失败')
                return
              }

              const startTime = Math.floor(Date.now() / 1000)
              const expiredTime = startTime + 1800

              callback({
                TmpSecretId: stsToken.data.accessKeyId,
                TmpSecretKey: stsToken.data.accessKeySecret,
                XCosSecurityToken: stsToken.data.securityToken,
                ExpiredTime: expiredTime,
                StartTime: startTime
              })
            } catch (error) {
              callback(error.message || '获取COS凭证失败')
            }
          },
          Protocol: 'https:',
          Timeout: 60000,
          UseAccelerate: false,
          CorrectClockSkew: true
        })

        // 3. 获取 bucket 和 region 信息
        const stsToken = await getSTSToken()
        if (!stsToken || !stsToken.data) {
          throw new Error('获取COS凭证失败')
        }

        const bucket = stsToken.data.bucket
        const region = stsToken.data.region

        // 4. 判断文件大小，选择上传方式
        const fileSize = info.file.size
        const isLargeFile = fileSize > 5 * 1024 * 1024 // 5MB

        let uploadResult
        if (isLargeFile) {
          uploadResult = await cos.uploadFile({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            SliceSize: 1024 * 1024 * 5,
            ContentType: info.file.type || 'application/octet-stream',
            Headers: {},
            onProgress: function(progressData) {
              if (findIndex != -1) {
                const percent = Math.round(progressData.percent * 100)
                that.$set(fileList[findIndex], 'percent', percent)
              }
            }
          })
        } else {
          uploadResult = await cos.putObject({
            Bucket: bucket,
            Region: region,
            Key: filePath,
            Body: info.file,
            ContentType: info.file.type || 'application/octet-stream',
            Headers: {},
            onProgress: function(progressData) {
              if (findIndex != -1) {
                let percent = 0
                if (progressData.percent !== undefined) {
                  percent = Math.round(progressData.percent * 100)
                } else if (progressData.loaded && progressData.total) {
                  percent = Math.round((progressData.loaded / progressData.total) * 100)
                }
                that.$set(fileList[findIndex], 'percent', percent)
              }
            }
          })
        }

        // 5. 检查上传结果并构建 URL
        if (uploadResult && (uploadResult.statusCode === 200 || uploadResult.ETag || uploadResult.Location)) {
          let url = ''
          if (stsToken.data.staticUrl) {
            url = stsToken.data.staticUrl + (stsToken.data.staticUrl.endsWith('/') ? '' : '/') + filePath
          } else if (uploadResult.Location) {
            url = uploadResult.Location
          } else {
            url = `https://${bucket}.cos.${region}.myqcloud.com/${filePath}`
          }
          // 确保 URL 包含 https:// 前缀
          url = ensureHttpsUrl(url)

          if (findIndex != -1) {
            that.$set(fileList[findIndex], 'percent', 100)
            that.$set(fileList[findIndex], 'status', 'done')
            that.$set(fileList[findIndex], 'url', url)
          }
        } else {
          throw new Error('上传失败，返回结果异常')
        }
      } catch (error) {
        console.error(`========== 上传失败 (${prefix}) ==========`)
        console.error('错误详情:', error)

        let errorMessage = '上传失败：'
        if (error.message) {
          errorMessage += error.message
        } else {
          errorMessage += '未知错误'
        }

        if (findIndex != -1) {
          that.$set(fileList[findIndex], 'status', 'error')
          that.$set(fileList[findIndex], 'percent', 0)
          that.$message.error(errorMessage)
        }
      }
    },

    async handleChangeEn(info) {
      await this.uploadToCos(info, this.fileEnList, 'subtitle/en', 'fileEnList')
    },

    async handleChangeCn(info) {
      await this.uploadToCos(info, this.fileCnList, 'subtitle/cn', 'fileCnList')
    },

    async handleChangeBm(info) {
      await this.uploadToCos(info, this.fileBmList, 'subtitle/bm', 'fileBmList')
    },

    async handleChangeIn(info) {
      await this.uploadToCos(info, this.fileInList, 'subtitle/in', 'fileInList')
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      const that = this
      if (this.fileList.length > 0 || this.fileEnList.length > 0 || this.fileZhList.length > 0 || this.fileCnList.length > 0 || this.fileBmList.length > 0 || this.fileInList.length > 0) {
        this.$confirm({
          content: '您上传的短剧/字幕文件尚未保存是否关闭',
          centered: true,
          onOk() {
            that.open = false
            that.fileList = []
            that.fileEnList = []
            that.fileZhList = []
            that.fileCnList = []
            that.fileBmList = []
            that.fileInList = []
          },
          onCancel() {
            // that.open = false
            // that.fileList = [];
            // that.fileEnList = [];
            // that.fileZhList = [];
          }
        })
      } else {
        this.open = false
        this.fileList = []
        this.fileEnList = []
        this.fileZhList = []
        this.fileCnList = []
        this.fileBmList = []
        this.fileInList = []
      }

      // // 关闭后刷新列表
      // this.$emit('ok')
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('/video/video-gather/importTemplate', {
        ...this.queryParams
      }, `gather_template_${new Date().getTime()}.xlsx`)
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.id = e
      this.open = true
    },
    beforeUpload (file) {
      this.fileList = [file]
      return false
    },
    /** 导入excel */
    importExcelHandleChange () {
      if (this.fileList.length > 0) {
        if (this.computedUploadVideoing != 0) {
          this.$message.error('剧集文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileInList.length > 0) {
        if (this.computedUploadIning != 0) {
          this.$message.error('字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileEnList.length > 0) {
        if (this.computedUploadEning != 0) {
          this.$message.error('英文字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileCnList.length > 0) {
        if (this.computedUploadCning != 0) {
          this.$message.error('法语字幕文件还未上传完毕,请耐心等待')
          return
        }
      }

      if (this.fileZhList.length > 0) {
        if (this.computedUploadZhing != 0) {
          this.$message.error('阿拉伯字幕文件还未上传完毕,请耐心等待')
          return
        }
      }



      // if (this.fileBmList.length > 0) {
      //   if (this.computedUploadBming != 0) {
      //     this.$message.error('西班牙语字幕文件还未上传完毕,请耐心等待')
      //     return
      //   }
      // }



      this.uploading = true
      // const { fileList } = this
      // const formData = new FormData()
      // formData.append('file', fileList[0])
      // formData.append('updateSupport', this.updateSupport)

      const arrList = this.fileList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        videoUrl: i.url,
        fileId: i.fileId,
        videoId: this.id
      }))
      const enList = this.fileEnList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitleEn: i.url,
        videoId: this.id
      }))
      const zhList = this.fileZhList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitle: i.url,
        videoId: this.id
      }))
      const cnList = this.fileCnList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitleCn: i.url,
        videoId: this.id
      }))
      // const bmList = this.fileBmList.map(i => ({
      //   serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
      //   subtitleBm: i.url,
      //   videoId: this.id
      // }))
      const inList = this.fileInList.map(i => ({
        serialNumber: /-/.test(i.name) ? i.name.split('.')[0].split('-')[1] : i.name.split('.')[0],
        subtitleIn: i.url,
        videoId: this.id
      }))
      const newArrData = {
        arrList: arrList,
        enList: enList,
        zhList: zhList,
        cnList: cnList,
        bmList: [],
        inList: inList
      }
      importData(JSON.stringify(newArrData)).then(response => {
        if (response.code == 1 || response.code == 20001) {
          this.fileList = []
          this.fileEnList = []
          this.fileZhList = []
          this.fileCnList = []
          this.fileBmList = []
          this.fileInList = []
          this.$message.success(response.message)
          this.open = false
          this.$emit('ok')
        } else {
          this.$message.error(response.message)
        }
      }).finally(() => {
        this.uploading = false
        this.$emit('ok')
      })
    },
    handleCheckedUpdateSupport () {
      this.updateSupport = this.updateSupport === 0 ? 1 : 0
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    },
    handleRemoveZh () {
      this.fileZhList = []
      this.uploading = false
    },
    handleRemoveEn () {
      this.fileEnList = []
      this.fileList = []
      this.uploading = false
    },
    handleRemoveCn () {
      this.fileCnList = []
      this.uploading = false
    },
    handleRemoveBm () {
      this.fileBmList = []
      this.uploading = false
    },
    handleRemoveIn () {
      this.fileInList = []
      this.uploading = false
    }
  }
}
</script>
